import React from 'react';
import PropTypes from 'prop-types';


const Score = ({ rating }) => {
  if (rating === null) {
    return '-';
  }
  const num = Number.parseFloat(rating);
  let score = 'u-bg-red';
  if (num >= 8) {
    score = 'u-bg-green-success';
  } else if (num >= 5) {
    score = 'u-bg-another-toasted-yellow';
  }
  let display = num.toFixed(1);
  display = display.endsWith('.0') ? display.slice(0, -2) : display;
  return (
    <span
      style={{ lineHeight: '1.5rem' }}
      className={`u-text-sm u-text-center u-h-6 u-w-6 u-inline-block u-text-white u-rounded-full ${score}`}
    >
      {display}
    </span>
  );
};

Score.propTypes = {
  rating: PropTypes.any,
};

Score.defaultProps = {
  rating: null,
};

export default Score;
